import { render, staticRenderFns } from "./TemplateTriggers.vue?vue&type=template&id=71f21475&scoped=true"
import script from "./TemplateTriggers.vue?vue&type=script&lang=js"
export * from "./TemplateTriggers.vue?vue&type=script&lang=js"
import style0 from "./TemplateTriggers.vue?vue&type=style&index=0&id=71f21475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f21475",
  null
  
)

export default component.exports